import { configureStore, createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Создаём асинхронный экшен для загрузки корзины
export const fetchAndSetUserCart = createAsyncThunk(
  "cart/fetchAndSetUserCart",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetch("/Cart/GetUserCart", {
        method: "GET",
        headers: { "Content-Type": "application/json" }
      });

      if (!response.ok) {
        throw new Error("Ошибка при загрузке корзины");
      }

      return await response.json();
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);
// Начальное состояние для корзины
const cartSlice = createSlice({
  name: 'cart',
  initialState: { cartAmount: 0, cartIds: [] },
  reducers: {
    addToCart: (state, param) => {
      if (!state.cartIds.includes(param.payload)) {
        state.cartIds.push(param.payload);
        state.cartAmount += 1;

      }
    },
    removeFromCart: (state, param) => {
      if (state.cartIds.includes(param.payload)) {
        const index = state.cartIds.indexOf(param.payload);
        // if (index > -1) { // only splice state.cartIds when item is found
        state.cartIds.splice(index, 1); // 2nd parameter means remove one item only
        // }
        state.cartAmount = Math.max(0, state.cartAmount - 1);
      }
    },
    // setAmount: (state, param) => {
    //   state.cartAmount = param.payload;
    // },
    setInitCart: (state, param) => {
      param.payload.forEach(x => {
        if (!state.cartIds.includes(x)) {
          state.cartIds.push(x);
        }
      })
      state.cartAmount = param.payload.length;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAndSetUserCart.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchAndSetUserCart.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.cartIds = action.payload.cartIds;
        state.cartAmount = action.payload.cartIds.length;
      })
      .addCase(fetchAndSetUserCart.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  }
});


export const fetchAndSetUserFavourite = createAsyncThunk(
  "favourite/fetchAndSetUserFavourite",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetch("/Favourite/GetUserFavourite", {
        method: "GET",
        headers: { "Content-Type": "application/json" }
      });

      if (!response.ok) {
        throw new Error("Ошибка при загрузке избранного");
      }

      return await response.json();
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);
const serviceSlice = createSlice({
  name: 'service',
  initialState: {
    isAuthenticated: false,
    email: ""
  },
  reducers: {
    setAuthenticated: (state, param) => {
      state.isAuthenticated = param.payload;
    },
    setGlobalEmail: (state, param) => {
      state.email = param.payload;
    }
  }
})
const favouriteSlice = createSlice({
  name: 'favourite',
  initialState: { favouriteAmount: 0, favouriteIds: [] },
  reducers: {
    addToFavourite: (state, param) => {
      if (!state.favouriteIds.includes(param.payload)) {
        state.favouriteIds.push(param.payload);
        state.favouriteAmount += 1;

      }
    },
    removeFromFavourite: (state, param) => {
      if (state.favouriteIds.includes(param.payload)) {
        const index = state.favouriteIds.indexOf(param.payload);
        // if (index > -1) { // only splice state.favouriteIds when item is found
        state.favouriteIds.splice(index, 1); // 2nd parameter means remove one item only
        // }
        state.favouriteAmount = Math.max(0, state.favouriteAmount - 1);
      }
    },
    setAmount: (state, param) => {
      state.favouriteAmount = param.payload;
    },
    setInitFavourite: (state, param) => {
      param.payload.forEach(x => {
        if (!state.favouriteIds.includes(x)) {
          state.favouriteIds.push(x);
        }
      })
      state.favouriteAmount = param.payload.length;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAndSetUserFavourite.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchAndSetUserFavourite.fulfilled, (state, action) => {
        state.status = "succeeded";
        if (action.payload.success) {
          state.favouriteIds = action.payload.favouriteIds;
          state.favouriteAmount = action.payload.favouriteIds.length;

        }
      })
      .addCase(fetchAndSetUserFavourite.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  }
});
// Создаем store с использованием configureStore
const store = configureStore({
  reducer: {
    cart: cartSlice.reducer,
    favourite: favouriteSlice.reducer,
    service: serviceSlice.reducer
  },
});
export const { addToCart, removeFromCart, setInitCart } = cartSlice.actions;
export const { addToFavourite, removeFromFavourite, setInitFavourite } = favouriteSlice.actions;
export const { setAuthenticated, setGlobalEmail } = serviceSlice.actions;
export default store;
